const module = { name: 'concessions/participatingTheatersLoader', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { swig as swig } from 'require-core';



import { fd_url_manager as links } from 'require-core';



import { Fandango_debugLog as debugLog } from 'require-core';



import { Fandango_dateUtil as Fandango_dateUtil_dateFromQuery } from 'require-global';

const { dateFromQuery } = Fandango_dateUtil_dateFromQuery;


// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { Fandango_util as Fandango_util_formatDate } from 'require-global';

const { formatDate } = Fandango_util_formatDate;


import { fd_location as fd_location_locationFormCreation_updateLocation_getLocation } from 'require-global';

const { locationFormCreation, updateLocation, getLocation } = fd_location_locationFormCreation_updateLocation_getLocation;


import { Fandango_xhr as xhr } from 'require-core';



import { Fandango as Fandango_logInUrls_context } from 'require-core';

const { logInUrls, context: { device: { isMobile } } } = Fandango_logInUrls_context;


import { Fandango_carousel as fdCarousel } from 'require-global';



import { default as hearts } from 'swug-fdRequire-call:shared/utils/hearts';



import { default as Fandango_triggerEvent_triggerAnalyticsEvent } from 'swug-fdRequire-call:Fandango/triggerEvent';

const { triggerAnalyticsEvent } = Fandango_triggerEvent_triggerAnalyticsEvent;


const concessionsMovieRegistry = Object.create(null)


const theaterLogoList = {
    AMC: 'https://images.fandango.co.uk/cms/assets/a5dbbf00-ff4d-11ed-9577-b524031771c2--chain-logo-amc-120x120.png',
    BRND: 'https://images.fandango.co.uk/cms/assets/beef1e60-ff4d-11ed-9d20-83ee649e98bd--chain-logo-brnd-120x120.png',
    CMX: 'https://images.fandango.co.uk/cms/assets/9531d8b0-ff4d-11ed-81d8-51a487a38835--chain-logo-cmx-120x120.png',
    CNMK: 'https://images.fandango.co.uk/cms/assets/b9815920-ff4d-11ed-a868-adceb8892ad3--chain-logo-cnmk-120x120.png',
    CWST: 'https://images.fandango.co.uk/cms/assets/885267e0-ff4d-11ed-9577-b524031771c2--chain-logo-cwst-120x120.png',
    GLXY: 'https://images.fandango.co.uk/cms/assets/04a26140-9716-11ef-ab6e-6bc4e16d49df--chain-logo-glxy-120x120-4.png',
    HRKN: 'https://images.fandango.co.uk/cms/assets/9f37eac0-ff4d-11ed-9577-b524031771c2--chain-logo-hrkn-120x120.png',
    MRCS: 'https://images.fandango.co.uk/cms/assets/b413e200-ff4d-11ed-81d8-51a487a38835--chain-logo-mrcs-120x120.png',
    NATA: 'https://images.fandango.co.uk/cms/assets/ad3b9040-ff4d-11ed-a868-adceb8892ad3--chain-logo-nata-120x120.png',
    REGL: 'https://images.fandango.co.uk/cms/assets/8e8ca4e0-ff4d-11ed-81d8-51a487a38835--chain-logo-regl-120x120.png'
}


const Selectors = {
    STEP_CARD_LINK: '.step-card__link',
    SEE_MORE_THEATERS: '.see-more-theaters__button',
    CONCESSIONS_OFFER_CTA: '.offers-carousel-container .carousel-link',
    FAQS_ACCORDION_SUMMARY: '.faqs-benefit__accordion-section-summary',
    FIND_PARTICIPATING_THEATERS: '.find-participating-theaters__button',
    CONCESSIONS_OFFER_ARROW_LEFT: '.offers-carousel-container .fd-carousel__arrow--left',
    CONCESSIONS_OFFER_ARROW_RIGHT: '.offers-carousel-container .fd-carousel__arrow--right',
    THEATER_NAME_LINK: '.concessions-theater__list .fd-theater__name',
    MOVIE_POSTER_LINK: '.concessions-section-data__container .splide a[href]',
    OFFERS_CAROUSEL_ROOT: '#offers-carousel'
}


const TARGET = '.js-participatingTheaters-loading'


const THEATERS_LIST_CONTAINER = '.js-theaters-list-container'


const LOAD_MORE_BTN_CONTAINER = '.js-load-more-btn-container'


const HIDE_CLASS = 'hide'


const PARTICIPATING_THEATERS_WRAPPER = '.js-participating-theaters-wrapper'


const MAX_RESULTS_PER_PAGE = 5


let currentPage = 1


const CONCESSIONS_API_OPERATOR = 'Any'


const CONCESSIONS_AMENITIES = ['ConcessionsPickup', 'DelivertoSeat', 'ExpressPickup']


const CONCESSIONS_ANALYTICS_PAGE = {
    pageName: 'concessions | how it works',
    pageType: 'concessions landing',
}
function triggerConcessionsAnalyticsEvent(eventName, extraData = {}) {
    triggerAnalyticsEvent(eventName, {
        ...CONCESSIONS_ANALYTICS_PAGE,
        event: eventName,
        eventName,
        ...extraData
    });
}
function buildParams(loc, page) {
    return {
        zipCode: loc.postalCode || '',
        city: loc.city || '',
        state: loc.region || loc.state || '',
        date: dateFromQuery() || formatDate(new Date()),
        page,
        limit: MAX_RESULTS_PER_PAGE,
        isdesktop: true,
        filter: 'open-theaters',
        filterEnabled: true,
        joinNowURL: logInUrls.joinNow,
        amenityCodes: CONCESSIONS_AMENITIES.join(','),
        amenityCodesOperator: CONCESSIONS_API_OPERATOR
    };
}
function handleLoadMore() {
    const currentLocation = processLocation(getLocation());
    if (currentLocation) {
        currentPage++;
        request(currentLocation, false);
    }
}
function processLocation(rawLocation) {
    if (!rawLocation && !rawLocation.city || !rawLocation.name) {
        onFail();
        return;
    }
    const updatedLocation = { ...rawLocation };
    const [city, state] = updatedLocation?.name?.split(', ') || [];
    if (city && state) {
        updatedLocation.city = city;
        updatedLocation.state = state;
    }
    return updatedLocation;
}
function onLocationChange() {
    $(TARGET).html(swig.render('_theatersPlaceholder', {
        isMobile
    })).show();
    $(THEATERS_LIST_CONTAINER).empty();
    $(LOAD_MORE_BTN_CONTAINER).hide();
    hearts.init();
    const newLocation = processLocation(getLocation());
    if (newLocation) {
        currentPage = 1;
        request(newLocation, true);
    }
    else {
        onFail('Please select another location to find cinemas.');
    }
}
function renderTheaters(theaters) {
    return swig.render('_theatersByLocation', {
        includeTheaterHeader: true,
        pagination: false,
        theaters: theaters || [],
        logos: theaterLogoList || [],
    });
}
function processCarousels($content) {
    const carouselsToShow = [];
    $content.find('.movie-carousel-placeholder').each(function () {
        const $placeholder = $(this);
        const carouselId = $placeholder.data('carousel-id');
        const moviesAttr = $placeholder.attr('data-movies');
        let moviesFromAPI = [];
        if (moviesAttr) {
            try {
                const parsedData = JSON.parse(moviesAttr);
                moviesFromAPI = Array.isArray(parsedData) ? parsedData : [parsedData];
            }
            catch (e) {
                return;
            }
        }
        if (carouselId && moviesFromAPI.length > 0) {
            const theaterName = $placeholder
                .closest('.fd-theater__content-container')
                .find('.fd-theater__name')
                .text()
                .trim();
            const byHref = Object.create(null);
            moviesFromAPI.forEach((m) => {
                if (m.mopURI) {
                    byHref[m.mopURI] = m.title;
                }
            });
            concessionsMovieRegistry[carouselId] = { theaterName, byHref };
            const mappedMovies = moviesFromAPI.map(movie => ({
                id: movie.id,
                title: movie.title,
                image: movie.poster,
                url: movie.mopURI
            }));
            const carouselMarkup = swig.render('_movieCarousel', {
                id: carouselId,
                movies: mappedMovies,
                hasGradient: !isMobile,
                isMobile
            });
            $placeholder.replaceWith(carouselMarkup);
            carouselsToShow.push(carouselId);
        }
    });
    return carouselsToShow;
}
function onFail(errorRequest = 'There was an error retrieving nearby cinemas.') {
    checkDependencies(module.name, debugLog);
    $(TARGET).html(`<p class="no-theaters">${errorRequest}</p>`);
}
function onDone(response, isInitialRequest) {
    const currentLocation = processLocation(getLocation());
    const theatersFiltered = Array.isArray(response.theaters) ? response.theaters : [];
    if (response.error && Object.keys(currentLocation).length === 0) {
        onFail('Please set your location to show cinemas nearby your area');
        return;
    }
    if (response.error || !Array.isArray(response.theaters)) {
        onFail('No Results. Try adjusting your location.');
        return;
    }
    if (theatersFiltered.length === 0) {
        onFail('No results with concessions enabled. Try adjusting your location.');
        return;
    }
    theatersFiltered.forEach((theater) => {
        if (theater.name) {
            theater.name = theater.name.toString().trim();
        }
        if (theater.distance) {
            theater.formattedDistance = typeof theater.distance !== 'number' ? '' : `${theater.distance.toFixed(1)} mi`;
        }
        if (Array.isArray(theater.amenities)) {
            theater.specialAmenities = theater.amenities.filter(amenity => CONCESSIONS_AMENITIES.includes(amenity.code));
        }
        else {
            theater.specialAmenities = [];
        }
    });
    const markup = renderTheaters(theatersFiltered);
    const $newContent = $(markup);
    const carouselsToInit = processCarousels($newContent);
    if (isInitialRequest) {
        const initialMarkup = `
        <div class="${THEATERS_LIST_CONTAINER.substring(1)}"></div>
        <div class="${LOAD_MORE_BTN_CONTAINER.substring(1)} see-more-theaters__container">
          <button class="see-more-theaters__button js-load-more-theaters">
            <span class="see-more-theaters__text">See More Cinemas</span>
            <span class="icon icon-arrow-down-blue see-more-theaters__arrow"></span>
          </button>
        </div>`;
        $(TARGET).html(initialMarkup);
        $(THEATERS_LIST_CONTAINER).html($newContent);
    }
    else {
        $(THEATERS_LIST_CONTAINER).find('.temp-placeholder').remove();
        $(THEATERS_LIST_CONTAINER).append($newContent);
    }
    const carouselOpts = {
        perPage: 5,
        autoWidth: true,
        padding: { left: 0, right: 0 },
        type: 'slide',
        hasGradient: true,
        lazyLoad: 'nearby'
    };
    carouselsToInit.forEach(id => fdCarousel.init(id, carouselOpts));
    hearts.init();
    if (theatersFiltered.length === MAX_RESULTS_PER_PAGE) {
        $(LOAD_MORE_BTN_CONTAINER).show();
    }
    else {
        $(LOAD_MORE_BTN_CONTAINER).hide();
    }
    $(document).on('click', Selectors.MOVIE_POSTER_LINK, (e) => {
        const element = e.currentTarget;
        const data = getMovieNameAndTheaterFromPoster(element);
        if (!data) {
            return;
        }
        const { movieTitle, theaterName, href } = data;
        triggerConcessionsAnalyticsEvent('movie poster click', { movieTitle, theaterName });
        if (href) {
            e.preventDefault();
            setTimeout(() => {
                window.location.href = href;
            }, 150);
        }
    });
}
function request(loc, isInitialRequest = false) {
    const pageToFetch = isInitialRequest ? 1 : currentPage;
    const $placeholder = $(swig.render('_theatersPlaceholder', { isMobile })).addClass('temp-placeholder');
    if (isInitialRequest) {
        $(TARGET).html(swig.render('_theatersPlaceholder', { isMobile }));
    }
    else {
        $(LOAD_MORE_BTN_CONTAINER).hide();
        $(THEATERS_LIST_CONTAINER).append($placeholder);
    }
    xhr.ajax({
        method: 'GET',
        url: links.napiTheaterWithShowtimes(),
        data: buildParams(loc, pageToFetch)
    })
        .done(response => onDone(response, isInitialRequest))
        .fail(err => onFail(err))
        .always(() => {
        const $loadMoreButton = $(`${LOAD_MORE_BTN_CONTAINER} button`);
        $loadMoreButton.prop('disabled', false);
        $loadMoreButton.find('.see-more-theaters__text').text('See More Cinemas');
    });
}
function getInfoFromCarousel(element) {
    const el = element instanceof HTMLElement ? element : element[0];
    const slideIndex = Number(el.getAttribute('data-slide-index')) || 1;
    const ctaLabel = el.getAttribute('data-cta-label') || el.getAttribute('aria-label') || el.textContent.trim() || 'cta';
    return { tilePosition: `tile number ${slideIndex}`, ctaLabel };
}
function getActiveSlideIndex(rootEl) {
    const root = rootEl instanceof HTMLElement ? rootEl : rootEl?.[0];
    const activeSlide = root?.querySelector('.splide__slide.is-active');
    const activeCta = activeSlide?.querySelector('[data-slide-index]');
    const idx = Number(activeCta?.getAttribute('data-slide-index'));
    return Number.isFinite(idx) ? idx : 1;
}
function getActiveOfferSlideInfo(rootEl) {
    const root = rootEl instanceof HTMLElement ? rootEl : rootEl?.[0];
    if (!root) {
        return { slideIndex: 1, sectionHeader: '' };
    }
    const slideIndex = getActiveSlideIndex(root);
    const activeSlide = root.querySelector('.splide__slide.is-active');
    const headerEl = activeSlide?.querySelector('.carousel-header');
    const sectionHeader = headerEl?.textContent?.trim() || '';
    return { slideIndex, sectionHeader };
}
function getTheaterInfoFromLink(anchorEl) {
    const el = anchorEl instanceof HTMLElement ? anchorEl : anchorEl?.[0];
    const container = el?.closest('.fd-theater__content-container');
    let theaterName = el?.getAttribute('data-theater-name') || 'Cinema name not found';
    if (!theaterName) {
        const aria = el?.getAttribute('aria-label') || '';
        const firstSentence = aria.split('.').shift()?.trim();
        theaterName = firstSentence || el?.textContent?.trim();
    }
    const theaterId = container?.getAttribute('data-theater-id') || null;
    return { theaterName, theaterId };
}
function getMovieNameAndTheaterFromPoster(anchorEl) {
    const el = anchorEl instanceof HTMLElement ? anchorEl : anchorEl?.[0];
    if (!el) {
        return null;
    }
    const splideRoot = el.closest('.splide');
    const carouselId = splideRoot?.id || splideRoot?.getAttribute('data-carousel-id') || null;
    const href = el.getAttribute('href') || '';
    let movieTitle = el.getAttribute('data-movie-title') || el.getAttribute('aria-label') || 'unknown movie';
    let theaterName = splideRoot?.closest('.fd-theater__content-container')?.querySelector('.fd-theater__name')?.textContent?.trim() ||
        el.closest('.fd-theater__content-container')?.querySelector('.fd-theater__name')?.textContent?.trim() ||
        'unknown cinema';
    if (carouselId && concessionsMovieRegistry[carouselId]) {
        const data = concessionsMovieRegistry[carouselId];
        theaterName = data.theaterName || theaterName;
        movieTitle = data.byHref?.[href] || movieTitle;
    }
    return { movieTitle, theaterName, href };
}
function init() {
    $(PARTICIPATING_THEATERS_WRAPPER).removeClass(HIDE_CLASS);
    const currentLocation = processLocation(getLocation());
    updateLocation(currentLocation);
    if (!isMobile) {
        locationFormCreation.init({
            dropdown: { name: 'concessionsModule', relativeParent: '#theaters-near-me-location' }
        });
    }
    locationFormCreation.attach(onLocationChange);
    $(document).on('click', '.js-load-more-theaters', handleLoadMore);
    $(document).on('click', Selectors.CONCESSIONS_OFFER_CTA, (e) => {
        e.preventDefault();
        const element = e.currentTarget;
        const { tilePosition, ctaLabel } = getInfoFromCarousel(element);
        triggerConcessionsAnalyticsEvent('concession carousel offers click', {
            position: tilePosition,
            buttonName: ctaLabel,
            carouselName: 'Concessions Offer Carousel'
        });
        const href = element.getAttribute('href');
        if (href) {
            e.preventDefault();
            setTimeout(() => {
                window.location.href = href;
            }, 150);
        }
    });
    $(document).on('click', `${Selectors.CONCESSIONS_OFFER_ARROW_LEFT}, ${Selectors.CONCESSIONS_OFFER_ARROW_RIGHT}`, function () {
        const root = this.closest('.splide');
        const buttonName = $(this).is(Selectors.CONCESSIONS_OFFER_ARROW_LEFT) ? 'left arrow' : 'right arrow';
        setTimeout(() => {
            const { slideIndex, sectionHeader } = getActiveOfferSlideInfo(root);
            triggerConcessionsAnalyticsEvent('concession carousel nav click', {
                carouselTilePosition: `${slideIndex} | ${buttonName}`,
                contentTitle: sectionHeader,
                carouselName: 'Concessions Offer Carousel'
            });
        }, 0);
    });
    $(document).on('click', Selectors.FIND_PARTICIPATING_THEATERS, (e) => {
        e.preventDefault();
        triggerConcessionsAnalyticsEvent('find theatres link click');
        const $target = $('.theaters__title');
        if ($target.length) {
            $('html, body').animate({
                scrollTop: $target.offset().top
            }, 1000);
        }
    });
    $(document).on('click', Selectors.STEP_CARD_LINK, (e) => {
        e.preventDefault();
        const element = e.currentTarget;
        triggerConcessionsAnalyticsEvent('find your link click');
        const href = element.getAttribute('href');
        if (href) {
            e.preventDefault();
            setTimeout(() => {
                window.location.href = href;
            }, 150);
        }
    });
    $(document).on('click', Selectors.THEATER_NAME_LINK, (e) => {
        const element = e.currentTarget;
        const { theaterName, theaterId } = getTheaterInfoFromLink(element);
        triggerConcessionsAnalyticsEvent('theater info carousel click', { theaterName, theaterId });
        const href = element.getAttribute('href');
        if (href) {
            e.preventDefault();
            setTimeout(() => {
                window.location.href = href;
            }, 150);
        }
    });
    $(document).on('click', Selectors.SEE_MORE_THEATERS, (e) => {
        e.preventDefault();
        triggerConcessionsAnalyticsEvent('see more theaters click');
    });
    $(document).on('click', Selectors.FAQS_ACCORDION_SUMMARY, function (event) {
        event.preventDefault();
        const $details = $(this).closest('.faqs-benefit__accordion-section-details');
        const $content = $details.find('.faqs-benefit__accordion-section-content');
        if ($details.attr('open')) {
            $content.slideUp(300, () => {
                $details.removeAttr('open');
            });
        }
        else {
            $details.attr('open', 'open');
            $content.hide().slideDown(300);
        }
    });
    if (currentLocation) {
        currentPage = 1;
        request(currentLocation, true);
    }
    else {
        onFail('Please select another location to find cinemas.');
    }
}
module.exports = {
    init
};
export default module.exports;